import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=704419b3&"
import script from "./credit.vue?vue&type=script&lang=js&"
export * from "./credit.vue?vue&type=script&lang=js&"
import style0 from "./credit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports